import { createContext, useCallback, useContext, useMemo, useState } from "react";

import { getAdminToken, setAdminToken } from "../lib/api";

interface AuthValue {
  token: string;
  hasToken: boolean;
  setToken: (t: string) => void;
  clear: () => void;
}

const AuthContext = createContext<AuthValue | null>(null);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [token, setTokenState] = useState<string>(() => getAdminToken());

  const setToken = useCallback((next: string) => {
    setTokenState(next);
    setAdminToken(next);
  }, []);

  const clear = useCallback(() => {
    setTokenState("");
    setAdminToken("");
  }, []);

  const value = useMemo<AuthValue>(
    () => ({ token, hasToken: token.length > 0, setToken, clear }),
    [token, setToken, clear]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth(): AuthValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
  return ctx;
}